export const PRESETS = ["#0B3B3C", "#1D4ED8", "#065F46", "#7C2D12", "#4C1D95", "#9F1239", "#0F172A", "#B45309"];

export function hexToHsl(hex) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || "");
  if (!m) return null;
  let [r, g, b] = [1, 2, 3].map((i) => parseInt(m[i], 16) / 255);
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0; const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h /= 6;
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

// Inline CSS variables so shadcn `bg-primary` etc. adopt the agency color on public pages.
export function brandVars(hex) {
  const hsl = hexToHsl(hex);
  return hsl ? { "--primary": hsl, "--ring": hsl } : {};
}
